    import { Fragment } from 'react'
import { t } from 'i18next'
import { Button, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'

const ServiceTravel = ({ modaltoggle, travelData }) => {
    const getIcon = (type) => {
        switch (type) {
            case 'current':
                return <i style={{ color: '#fff' }} className="fa fa-location-arrow"></i>;
            case 'office':
                return <i style={{ color: 'var(--theme-secondary)' }} className="fa fa-home"></i>;
            case 'stop':
                return <i style={{ color: '#dc3545' }} className="fa fa-stop-circle"></i>;
            default:
                return '';
        }
    }

    return (
        <Fragment>
            <ModalHeader toggle={modaltoggle}>
                {t('service.single.viewTravel')}
            </ModalHeader>

            <ModalBody className="py-4">
                <div className="travel-timeline">
                    {travelData?.map((travel, index) => {
                        const isLast = index === travelData.length - 1;

                        return (
                            <div
                                key={index}
                                className={`timeline-item ${
                                    travel.type === 'current' ? 'active' : ''
                                }`}
                            >
                                {!isLast && <div className="timeline-line" />}
                                <div className="timeline-icon">
                                    {getIcon(travel.type)}
                                </div>
                                <div className="timeline-content">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        <span className="location-title">
                                            {travel.label}
                                        </span>

                                        {travel.km && (
                                            <span className="distance-badge">
                                                {travel.km} {t('km')}
                                            </span>
                                        )}
                                    </div>
                                    {travel.type === 'current' && (
                                        <small className="text-current fw-semibold">
                                            {t('service.single.current')}
                                        </small>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={modaltoggle}>{t('close')}</Button>
            </ModalFooter>
            <style>
                {`
                    .travel-timeline {
                        position: relative;
                        padding: 10px 0;
                    }

                    .timeline-item {
                        position: relative;
                        display: flex;
                        align-items: center;
                        gap: 14px;
                        padding-bottom: 28px;
                    }

                    .timeline-item:last-child {
                        padding-bottom: 0;
                    }

                    .timeline-line {
                        position: absolute;
                        left: 15px;
                        top: 38px;
                        width: 2px;
                        height: calc(100% - 10px);
                        background: #dcdcdc;
                    }

                    .timeline-icon {
                        width: 32px;
                        height: 32px;
                        min-width: 32px;
                        border-radius: 50%;
                        background: #f1f3f5;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 1;
                        font-size: 15px;
                        color: #495057;
                        border: 2px solid #fff;
                        box-shadow: 0 0 0 1px #dee2e6;
                    }

                    .timeline-content {
                        flex: 1;
                        background: #f8f9fa;
                        border-radius: 6px;
                        padding: 12px 14px;
                        border: 1px solid #ececec;
                    }

                    .location-title {
                        font-weight: 600;
                        color: #212529;
                    }

                    .text-current {
                        color: var(--theme-default);
                    }

                    .distance-badge {
                        background: #e9ecef;
                        color: #495057;
                        font-size: 12px;
                        font-weight: 600;
                        padding: 4px 10px;
                        border-radius: 30px;
                    }

                    .timeline-item.active .timeline-icon {
                        background: var(--theme-default);
                        color: white;
                        box-shadow: 0 0 0 4px rgba(13,110,253,0.15);
                    }

                    .timeline-item.active .timeline-content {
                        border-color: rgba(13,110,253,0.25);
                        background: rgba(13,110,253,0.04);
                    }
                `}
            </style>
        </Fragment>
    )
}

export default ServiceTravel